// Copyright 2025, University of Maryland, All Rights Reserved
import { Button } from "@/components/ui/button"
import { AlertTriangle, CheckCircle } from "lucide-react"
import { type DatasourceBillVersion } from '@/types/datasource-bill'

interface BillVersionSelectorProps {
  versions: DatasourceBillVersion[]
  selectedVersion: number | null
  onVersionChange: (versionNumber: number) => void
}

const getAmendmentStatus = (version: DatasourceBillVersion): boolean | null => {
  return version.amendments_detected
}

export function BillVersionSelector({ versions, selectedVersion, onVersionChange }: BillVersionSelectorProps) {
  return (
    <div className="flex items-center gap-2 pt-2">
      <span className="text-sm font-medium text-muted-foreground">Version:</span>
      <div className="flex items-center gap-1 flex-wrap">
        {versions.map((version) => {
          const amendmentStatus = getAmendmentStatus(version)
          return (
            <Button
              key={version.version}
              variant={selectedVersion === version.version ? "default" : "outline"}
              size="sm"
              onClick={() => onVersionChange(version.version)}
              className="flex items-center gap-1 h-7"
            >
              <span className="font-mono">V{version.version}</span>
              {amendmentStatus === true && (
                <AlertTriangle className="h-3 w-3 text-red-500" />
              )}
              {amendmentStatus === false && (
                <CheckCircle className="h-3 w-3 text-green-500" />
              )}
            </Button>
          )
        })}
      </div>
    </div>
  )
}
